import {useQueryParamValue} from '@hconnect/common/query-params'
import {plantTimezonedDateRangeValidator} from '@hconnect/common/utils'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {
  AllFilterOptions,
  filterPageKeys,
  filterSettingsToUrl,
  getPageScopedFilters,
  FilterOptions,
  Page
} from '@widgets/shift-event-filters'
import {isUndefined, omit} from 'lodash'
import {useCallback, useMemo, useState} from 'react'

const EVENT_FILTERS = 'eventsFilters'

type PageFiltersResult = [FilterOptions, (filterOptions: FilterOptions) => void]

export const useShiftSummaryPageFilters = (
  plantId: string,
  defaultFilters?: Partial<AllFilterOptions>
): PageFiltersResult => {
  const timezone = useUpmPlantTimezone(plantId)
  const keys = useMemo(() => ['timeRange', ...filterPageKeys[Page.Summary]], [])
  const [eventFilters = '', setEventFilters] = useQueryParamValue(EVENT_FILTERS, keys, {
    keepInLocalStorage: true
  })

  const [filters, setFilters] = useState<FilterOptions>(
    getPageScopedFilters(eventFilters, Page.Summary, timezone, defaultFilters)
  )

  const setFilterValue = useCallback(
    (filterOptions: FilterOptions) => {
      if (Object.values(filterOptions).every(isUndefined)) {
        setEventFilters('')
        setFilters({})
        return
      }
      const filtersWithoutFreeText = omit(filterOptions, 'freeText')
      plantTimezonedDateRangeValidator(timezone, filtersWithoutFreeText.timeRange)
      setEventFilters(filterSettingsToUrl(filtersWithoutFreeText))
      setFilters(filterOptions)
    },
    [setEventFilters, timezone]
  )

  return [filters, setFilterValue]
}
